module.exports = __webpack_public_path__ + "img/bg_login.7b4b261b.png";